<script lang="ts">
    import { toast } from "@zerodevx/svelte-toast";
    import { apiClient } from "./apiClient";

    let username = "";
    let password = "";
    let isLoading = false;

    async function handleLogin() {
        if (!username || !password) {
            toast.push("Bitte Benutzername und Passwort eingeben", {
                theme: {
                    "--toastColor": "mintcream",
                    "--toastBackground": "rgba(220, 53, 69, 0.9)",
                    "--toastBarBackground": "#dc3545",
                },
            });
            return;
        }

        isLoading = true;
        try {
            await apiClient.login(username, password);
            toast.push("Erfolgreich angemeldet!", {
                theme: {
                    "--toastColor": "white",
                    "--toastBackground": "rgba(40, 167, 69, 0.9)",
                    "--toastBarBackground": "#28a745",
                },
            });
        } catch (err) {
            toast.push(
                err instanceof Error ? err.message : "Login fehlgeschlagen",
                {
                    theme: {
                        "--toastColor": "mintcream",
                        "--toastBackground": "rgba(220, 53, 69, 0.9)",
                        "--toastBarBackground": "#dc3545",
                    },
                },
            );
        } finally {
            isLoading = false;
        }
    }

    function handleSubmit(event: Event) {
        event.preventDefault();
        handleLogin();
    }
</script>

<main class="login-container">
    <div class="login-card">
        <h1>🍹 Bestellungen</h1>
        <h2>Anmeldung</h2>

        <form on:submit={handleSubmit}>
            <div class="form-group">
                <label for="username">Benutzername:</label>
                <input
                    id="username"
                    type="text"
                    bind:value={username}
                    disabled={isLoading}
                    required
                />
            </div>

            <div class="form-group">
                <label for="password">Passwort:</label>
                <input
                    id="password"
                    type="password"
                    bind:value={password}
                    disabled={isLoading}
                    required
                />
            </div>

            <button type="submit" disabled={isLoading}>
                {#if isLoading}
                    Anmelden...
                {:else}
                    Anmelden
                {/if}
            </button>
        </form>
    </div>
</main>

<style>
    .login-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background: linear-gradient(135deg, #ff7e5f, #feb47b);
        font-family: "Content", serif;
    }

    .login-card {
        background: white;
        padding: 2rem;
        border-radius: 15px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
        width: 100%;
        max-width: 400px;
    }

    h1 {
        font-family: "Title", cursive;
        text-align: center;
        color: #2c3e50;
        margin-bottom: 0.5rem;
        font-size: 3rem;
    }

    h2 {
        text-align: center;
        color: #34495e;
        margin-bottom: 2rem;
        font-size: 1.5rem;
        font-family: "Content", serif;
    }

    .form-group {
        margin-bottom: 1.5rem;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: bold;
        color: #2c3e50;
        font-family: "Content", serif;
    }

    input {
        width: 100%;
        box-sizing: border-box;
        padding: 0.75rem;
        border: 2px solid #bdc3c7;
        border-radius: 8px;
        font-size: 1rem;
        font-family: "Content", serif;
        transition: border-color 0.3s;
    }

    input:focus {
        outline: none;
        border-color: #ff7e5f;
    }

    input:disabled {
        background-color: #ecf0f1;
        cursor: not-allowed;
    }

    button {
        width: 100%;
        padding: 0.75rem;
        background: linear-gradient(135deg, #ff7e5f, #feb47b);
        color: white;
        border: none;
        border-radius: 8px;
        font-size: 1rem;
        font-family: "Content", serif;
        font-weight: bold;
        cursor: pointer;
        transition:
            transform 0.2s,
            box-shadow 0.2s;
    }

    button:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 126, 95, 0.3);
    }

    button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
</style>
